var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarActiveLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 76,
    viewBox: "0 0 12 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H0C6.62742 12 12 6.62742 12 0V12Z",
    fill: "#FBFAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 64H0C6.62742 64 12 69.3726 12 76V64Z",
    fill: "#FBFAF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 12,
    height: 52,
    fill: "#FAF9F6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarActiveLink);
export default __webpack_public_path__ + "static/media/sidebar-active-link.aeb79f1dcb087ce64df57110c7b0a81a.svg";
export { ForwardRef as ReactComponent };